import { Radio } from '@mui/material';
import { useTheme } from '@mui/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface FormControlProps {
  isLocked?: boolean;
  isSelected: boolean;
}

export const FormControl = ({ isLocked, isSelected }: FormControlProps) => {
  const theme = useTheme();
  if (isLocked)
    return (
      <LockOutlinedIcon
        style={{
          color: theme.palette.grey[400],
          marginLeft: theme.spacing(1),
          marginRight: theme.spacing(1.25),
          cursor: 'not-allowed',
        }}
      />
    );

  return (
    <Radio
      sx={{
        color: theme.palette.grey[900],
        '&, &.Mui-checked': {
          color: isSelected
            ? theme.palette.secondary.dark
            : theme.palette.grey[400],
        },
      }}
      checked={isSelected}
    />
  );
};
